export const formatDateTime = (h, display_time) => {
  return h('div', [
    h('span', {
      directives: [
        {
          name: 'time_format3',
          value: display_time
        }
      ]
    })
  ])
}

export const formatDate = (h, display_time) => {
  return h('div', [
    h('span', {
      directives: [
        {
          name: 'time_format',
          value: display_time
        }
      ]
    })
  ])
}

export const booleanChinese = (h, bool) => {
  let color, text
  if (bool) {
    color = 'green'
    text = '是'
  } else {
    color = 'red'
    text = '否'
  }
  return tagColor(h, color, text)
}

export const paymentChinese = (h, payment_method) => {
  let color, text
  if (payment_method === 'unpaid') {
    color = 'red'
    text = '待支付'
  } else if (payment_method === 'refund') {
    color = 'pink'
    text = '已退款'
  } else if (payment_method === 'refunded') {
    color = 'pink'
    text = '已退款'
  } else if (payment_method === 'pending') {
    color = 'pink'
    text = '挂单中'
  } else if (payment_method === 'paid') {
    color = 'green'
    text = '已支付'
  } else if (payment_method === 'unreceived') {
    color = 'blue'
    text = '待收货'
  } else if (payment_method === 'unreviewed') {
    color = 'yellow'
    text = '待评价'
  } else if (payment_method === 'finished') {
    color = 'cyan'
    text = '已完成'
  } else if (payment_method === 'cancelled') {
    color = 'grey'
    text = '已取消'
  } else if (payment_method === 'waiting_confirmed') {
    color = 'yellow'
    text = '等待商家验证'
  }
  return tagColor(h, color, text)
}

export const tagColor = (h, color, text) => {
  return h(
    'Tag',
    {
      props: {
        color: color
      }
    },
    text
  )
}

export const tableAvatar = (h, avatar) => {
  if (avatar) {
    return h('img', {
      attrs: {
        src: avatar,
        width: 60,
        height: 60
      }
    })
  }
}

export const deleteButtonInTable = (vm, h, params) => {
  return h(
    'Poptip',
    {
      props: {
        confirm: true,
        title: '您确定要删除这条数据吗?',
        transfer: true
      },
      on: {
        'on-ok': () => {
          vm.destroy(params.row.id)
        }
      }
    },
    [
      h(
        'Button',
        {
          style: {
            margin: '2px 5px'
          },
          props: {
            type: 'error',
            placement: 'top'
          }
        },
        '删除'
      )
    ]
  )
}

export const editorButtonInTable = (vm, h, params) => {
  return h(
    'Button',
    {
      props: {
        type: 'info'
      },
      style: {
        margin: '2px 5px'
      },
      on: {
        click: () => {
          vm.formType = 'edit'
          vm.modalShow = true
          vm.show(params.row.id)
        }
      }
    },
    '查看'
  )
}

export const commonButtonInTable = (vm, h, style, title, action, params) => {
  return h(
    'Button',
    {
      props: {
        type: style
      },
      style: {
        margin: '2px 5px'
      },
      on: {
        click: () => {
          action(...params)
        }
      }
    },
    title
  )
}

export const commonButtonInTable2 = (vm, h, props, title, action, params) => {
  return h(
    'Button',
    {
      props,
      style: {
        margin: '2px 5px'
      },
      on: {
        click: () => {
          action(...params)
        }
      }
    },
    title
  )
}

export const podStatus = (h, status) => {
  let color, text
  if (status === 'cash_pay') {
    color = 'green'
    text = '现金'
  } else if (status === 'svc_pay') {
    color = 'pink'
    text = '储值卡'
  } else if (status === 'lcsw_wx_pay') {
    color = 'green'
    text = '微信线上'
  } else if (status === 'lcsw_ali_pay') {
    color = 'blue'
    text = '支付宝线上'
  } else if (status === 'bank_card') {
    color = 'red'
    text = '银行卡'
  } else if (status === 'alipay_offline') {
    color = 'blue'
    text = '支付宝线下'
  } else if (status === 'wx_pay_offline') {
    color = 'green'
    text = '微信线下'
  } else if (status === 'meituan_pay_offline') {
    color = 'yellow'
    text = '美团-线下'
  } else if (status === 'scan_code_pay') {
    color = 'cyan'
    text = '扫码'
  } else if (status === 'alipay_facepay') {
    color = 'blue'
    text = '扫脸'
  }
  return tagColor(h, color, text)
}
export const bannerCategory = (h, status) => {
  let color, text
  if (status === 'picture') {
    color = 'blue'
    text = '图片'
  } else if (status === 'video') {
    color = 'red'
    text = '视频'
  } else {
    color = 'black'
    text = '未设置'
  }
  return tagColor(h, color, text)
}
export const bannerPlatform = (h, status) => {
  let color, text
  if (status === 'mini') {
    color = 'green'
    text = '小程序'
  } else if (status === 'front') {
    color = 'pink'
    text = '前台'
  } else if (status === 'splash') {
    color = 'yellow'
    text = '小程序开屏'
  } else {
    color = 'black'
    text = '未设置'
  }
  return tagColor(h, color, text)
}
export const tableVideo = (h, url) => {
  console.info(h, url)
  if (url) {
    return h('video', {
      attrs: {
        src: url,
        width: 60,
        height: 60
      }
    })
  }
}
